<template>
  <v-dialog v-model="show">
    <v-card class="pb-4">
      <v-card-title primary-title>
        <span class="headline mb-0">詳細情報</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="order.status != '指示Mail送信済'" @click="save">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="show = false" class="ml-2">{{
          $t('app.buttons.back')
        }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="D/O NO(親)"
                v-model="order.doNo"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.etd')"
                v-model="order.etd"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.eta')"
                v-model="order.eta"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.loadingPort')"
                disabled
                v-model="order.loadingPortCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.dischargePort')"
                disabled
                v-model="order.dischargePortCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.transportMode')"
                disabled
                v-model="order.transportModeCode"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                disabled
                label="フライトNO"
                v-if="order.isAir"
                v-model="order.volNo"
              ></v-text-field>
              <v-text-field
                disabled
                label="本船"
                v-else
                v-model="order.shipName"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                clearable
                disabled
                label="予定納入場所"
                url="warehouses/sjl-kv"
                v-model="order.finallyWarehouseId"
              ></remote-autocomplete>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                disabled
                label="納入予定日時間"
                v-model="order.forecastDeliveryDate"
              ></v-text-field>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="コメント"
                v-model="order.remark"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-data-table
        :headers="headers"
        :items="order.packages"
        :rows-per-page-items="[10]"
        hide-actions
        item-key="seq"
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.invoiceNo }}</td>
          <td>
            {{
              order.bookingType ? '-----' : props.item.paid ? '有償' : '無償'
            }}
          </td>
          <td>{{ props.item.skuCode }}</td>
          <td>{{ props.item.flag }}</td>
          <td>{{ props.item.cartonStartNo }}</td>
          <td>{{ props.item.cartonEndNo }}</td>
          <td>{{ props.item.perCartonQty }}</td>
          <td>{{ props.item.totalQty }}</td>
          <td>{{ props.item.left }}</td>
          <td>{{ props.item.containerNo }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    order: {},
    selected: [],
    headers: [
      { text: '海外取引先', value: 'partnerName', sortable: false },
      { text: 'I/V NO', value: 'invoiceNo', sortable: false },
      { text: '有償/無償', value: 'paid', sortable: false },
      { text: '品番', value: 'skuCode', sortable: false },
      { text: '識別No.', value: 'flag', sortable: false },
      { text: 'Carton Start', value: 'cartonStartNo', sortable: false },
      { text: 'Carton End', value: 'cartonEndNo', sortable: false },
      { text: '入れ数', value: 'perCartonQty', sortable: false },
      { text: '数量', value: 'totalQty', sortable: false },
      { text: '数量残', value: 'left', sortable: false },
      { text: 'コンテナNO', value: 'containerNo', sortable: false },
    ],
    resolve: null,
    reject: null,
  }),
  methods: {
    popup(id) {
      return this.$http.get(`/delivery-orders/doId/${id}`).then((res) => {
        this.order = {
          ...res.data,
          sjlWarehouseId:
            res.data.sjlWarehouseId || res.data.initSjlWarehouseId,
        }
        this.order.packages.forEach((o) => {
          o.doNo = this.order.doNo
          o.partnerName = this.order.partnerName
        })

        this.show = true
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      })
    },
    save() {
      this.resolve(this.order)
      this.show = false
    },
  },
}
</script>
